
import React from 'react';
import { useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../common/client/components/Text';

import OverviewPanel from './OverviewPanel';

const classNames = mergeStyleSets({
    list: {
        overflowY: 'auto',
        maxHeight: 300
    },
    error: {
        paddingTop: 8,
        paddingBottom: 8,
        color: '#ff0000'
    }
});

const ProjectLog = (props) => {
    return (
        <Stack verticalfill className={classNames.list}>
            {props.data.map(item => {
                return (
                    <Stack horizontal key={item.id}>
                        <Text>{item.msg}</Text>
                    </Stack>
                );
            })}
        </Stack>
    );
}

const OverviewPanelImportError = (props) => {

    const loaded = useSelector(state => state.project.loaded);
    const projectLog = useSelector(state => state.project.data.project.log);

    return (
        <OverviewPanel title="PROTOKOL ZPRÁV" loaded={loaded}>
            <div className={classNames.error}>
                <Text bold large>Při importu katastrálních dat došlo k chybě.</Text>
            </div>
            <ProjectLog data={projectLog} />
        </OverviewPanel>
    );
}

export default OverviewPanelImportError;
